import { createTheme, ThemeOptions } from '@mui/material/styles';
import { theme as mainTheme } from 'copyright-clearance-center-common-ui-react';

const rfeTheme = {
	...mainTheme,
	spacing: factor => `${0.25 * factor}rem`
};

const theme = createTheme(rfeTheme as ThemeOptions);

export default theme;
